import React from "react";
import styled from "styled-components";
import {IconAlert} from "../icons";
import {FiCheck} from "react-icons/fi";
import {EAlert} from "../../enums";

const AlertBigCont = styled.div`
		position: relative;
    display: flex;
    width: 100%;
    padding: 16px 20px;
		margin-bottom: 1rem;
    /*flex-direction: column;
    align-items: flex-start;*/
    gap: 10px;
		
		&:before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				width: 4px;
				height: 100%;
				display: block;

        background: var(--it-bg-buttons);
		}

    &[data-type='error'] {
        &:before {
            background: var(--it-text-red);
        }
    }

    &[data-type='success'] {
        &:before {
            background: var(--it-text-green);
        }
    }
`

const AlertTitle = styled.p`
		margin-bottom: 16px;
    color: var(--it-text-white);
    /* H4 */
    font-family: "Druk Wide";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%; /* 16.8px */
    letter-spacing: 0.42px;
    text-transform: uppercase;
`

const AlertIconPlace = styled.i`
    display: flex;
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    aspect-ratio: 1/1;

    border-radius: 999px;
    background: var(--it-bg-buttons);
		
		&[data-type='error'] {
        background: var(--it-bg-red);
		}

    &[data-type='success'] {
        background: var(--it-text-green);
    }
`
const AlertBigInnerCont = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
`

const AlertContent = styled.div`

`

export const AlertBigInfoText = styled.p`
    margin-bottom: 8px;
    color: var(--it-text-grey);
    /* Body */
    font-family: "Basis Grotesque Pro";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 16.8px */
    letter-spacing: 0.42px;
`

export const FiCheckIcon = styled(FiCheck)`
    color: var(--it-text-white);
    stroke: currentColor;
`

export const AlertBig = ({children, title = '', type = ''}) => {
	const _renderIcon = () => {
		switch (type) {
			case EAlert.success: {
				return (
					<FiCheckIcon
						size={20}
					/>
				)
			}
			case EAlert.error:
			default: {
				return (
					<IconAlert size={20} fill={`var(--it-text-red)`}/>
				)
			}
		}
	}

	return (
		<AlertBigCont data-type={type}>
			<AlertBigInnerCont>
				<AlertIconPlace data-type={type}>
					{_renderIcon()}
				</AlertIconPlace>

				<AlertContent>
					<AlertTitle data-type={type}>
						{title}
					</AlertTitle>

					{children}
				</AlertContent>
			</AlertBigInnerCont>
		</AlertBigCont>
	)
}